import { Component, OnInit } from '@angular/core';

@Component({
    templateUrl: 'info.component.html',
  standalone: false
})
export class InfoComponent implements OnInit {
    constructor() { }

    ngOnInit(): void {
        document.querySelector("body").classList.remove("opened");
     }
}
